module.exports = __webpack_public_path__ + "img/default-product-image.9d8521e3.jpg";